import styled from 'styled-components'
import { Box } from '@ally/metronome-ui'

type AccountGroupProps = {
  name: string
}

const AccountGroup = styled(Box).attrs<{ name: AccountGroupProps }>(props => ({
  'data-testid': `account-card-${props.name}`,
}))<AccountGroupProps>`
  ${({ theme: { space } }): string =>
    `
    margin-bottom: ${space.sm};

    > div {
      border-radius: 4px;
    }
  `};
`

export default AccountGroup
